import InsertOfferWrapper from "components/InsertOfferWrapper";
import PriceForm from "scenes/InsertOffer/form/Price";
import { CustomAppPage } from "src/types/types";

const Price: CustomAppPage = () => (
  <InsertOfferWrapper title="Údaje o ceně a dostupnosti">
    <PriceForm buttonNextText="Další" />
  </InsertOfferWrapper>
);

Price.hasHiddenFooter = true;

export default Price;
